<template>
<!-- 数据库 -->
    <div class="main_container">
        <!-- 查询部分 -->
       <div class="condition_box clearfix">
          <el-form :inline="true" :model="filters">
            <el-radio-group  v-model="radio" @change="changeClick" >
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-radio label="1">
                    <span>按年统计</span>
                    <el-date-picker
                    v-model="value1"
                    value-format="yyyy"
                    type="year"
                    placeholder="选择年">
                    </el-date-picker>
                    至
                    <el-date-picker
                    v-model="value2"
                    type="year"
                    value-format="yyyy"
                    placeholder="选择年">
                    </el-date-picker>
                </el-radio>
            </el-col>
            <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
                <el-radio  label="2">
                    <span>按月统计</span>
                    <el-date-picker
                    v-model="value3"
                    value-format="yyyy-MM"
                    type="month"
                    placeholder="选择月">
                    </el-date-picker>
                    至
                    <el-date-picker
                    v-model="value4"
                    type="month"
                    value-format="yyyy-MM"
                    placeholder="选择月">
                    </el-date-picker>
                </el-radio>
                <el-button type="primary" @click="getCount">统计</el-button>
            </el-col>
            </el-radio-group>
          </el-form>
       </div>
       <!-- 内容部分 -->
       <div class="table_box" :class="radioValue==1?'showTable':''">
           <div class="table_title" >{{tableTitle}}</div>
            <my-table :items="tableDataDetail" :headers="tableHeaderDetail" :oprateBtns="oprateBtns" :selectShow="false" :showPageNation="false" :oprateOption="oprateOption"  :listLoading="listLoadingDetail"   :totalNum="TotalNumDetail" :pageSize="detileParams.pageSize" @getTableData="getTableDataDetail">
            </my-table>
            <div class="chart-container">
                <div  class="table_title">{{chartTitle}}</div>
                <div id="chartColumn" style="width:1200px; height:400px;"  v-show="ifShowEchart"></div>
            </div>
       </div>
       <!-- <div class="table_box" :class="radioValue==2?'showTable':''">
            <div class="table_title" >{{tableTitle2}}</div>
             <my-table :items="tableDataDetail2" :headers="tableHeaderDetail2" :oprateBtns="oprateBtns2" :selectShow="false" :showPageNation="false" :oprateOption="oprateOption2"  :listLoading="listLoadingDetail2"   :totalNum="TotalNumDetail2" :pageSize="detileParams2.pageSize" @getTableData="getTableDataDetail2">
                <template slot-scope="{props}" slot="caozuo">
                <span class="caozuo_span" @click="getDetailPage(props.row.ID)">查看</span>
                </template>
                <template slot-scope="{props}" slot="CheckStatusText">
                    <span>{{props.row.CheckStatusText}}</span>
                </template>
            </my-table>
            <div class="chart-container" style="width:100%;">
                <div  class="table_title">{{chartTitle2}}</div>
                <div id="chartColumn2" style="width:1300px; height:400px;"></div>
            </div>
       </div> -->
    </div>
</template>
<script>
//GetCountBysearchParam
import MyTable from '@/components/Table'
import FileSaver from "file-saver";
import XLSX from "xlsx"
import echarts from 'echarts'

export default {
    components: {
        MyTable
    },
    data(){
        return{
            ifShowEchart:false,
            radioValue:"",
            tableTitle:"",
            chartTitle:'',
            tableTitle2:"2018年1月至2018年4月撤除申请数量统计表",
            chartTitle2:"2018年1月至2018年4月撤除申请数量柱状图",
            value1:"",
            value2:"",
            value3:"",
            value4:"",
            dataTime:"",
            radio:'1',
            input2:"",
            input21:"",
            filters:{},
            tableData3: [],
        border:true,
        currentPage1: 5,
        chartColumn: null,
        chartColumn2:null,
        oprateBtns: [
            {text: '编辑', method: 'editFn'},
        ],
        tableHeaderDetail:[
            // {prop: 'CreateYear', label: '年份'},
            // {prop: 'SUMCount', label: '撤除申请总数'},//
            // {prop: 'SuccessCount', label: '撤除成功总数'},
            // {prop: 'FailCount', label: '撤除失败总数',},
        ],
        tableDataDetail:[],
        listLoadingDetail:true,
        TotalNumDetail:1,
        commitText: '',
        oprateOption:{
            hasOprate:false,
            oprateName:"操作",
            width:""
        },
        checkStatusSelect:"",
        detileParams:{
            checkStatus:'2',
            // checkStatusList:[],
            requesterName:"",
            requesterPhoneNum:'',
            requesterOrganisation:"",
            articleName:"",
            author:"",
            publication:"",
            publishTime:"",
            pageIndex:1,//第几页
            pageSize:20//每页多少条
        },
        sourceData:[
                        {product: '2018', '申请总数': 43.3, '成功数量': 85.8, '失败数量': 93.7},
                        {product: '2019', '申请总数': 83.1, '成功数量': 73.4, '失败数量': 55.1},
                    ]

        }
    },
    methods:{
        changeClick(){
            var _this = this;
            _this.value1="";
            _this.value2="";
            _this.value3="";
            _this.value4="";
        },
        handleClick(row){
            // this.$router.push('/applyIndex/viewCancel');
            console.log("row---",row.id);
            this.$router.push({
                path:"/viewInfo",
                name:'撤除申请详情',
                params:{
                    id:row.id
                }
            });
        },
        getTableDataDetail(paramaData){
            var _this = this;
            this.listLoadingDetail = true;
            _this.$api.GetCountBysearchParam(paramaData).then(res =>{
                console.log("res==============",res)
                if(res.data.result){
                    var tableData = res.data.info.SearchList || [];
                    var sourceData =[];
                    // [
                    //     {product: '2018', '申请总数': 43.3, '成功数量': 85.8, '失败数量': 93.7},
                    //     {product: '2019', '申请总数': 83.1, '成功数量': 73.4, '失败数量': 55.1},
                    // ]
                    _this.tableDataDetail=tableData
                    this.listLoadingDetail = false;
                    tableData.forEach(item => {
                        sourceData.push({
                            product:item.CreateYear,
                            "申请总数":item.SUMCount,
                            "成功数量":item.SuccessCount,
                            "失败数量":item.FailCount
                        })
                    });
                    if(sourceData.length>0){
                        debugger
                        _this.ifShowEchart=true;
                        if(_this.radio==1){
                            _this.drawColumnChart(sourceData,"年份")
                        }else{
                            _this.drawColumnChart(sourceData,"月份")
                        }

                    }else{
                        _this.ifShowEchart=false;
                        _this.chartTitle=""
                    }

                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })

        },
        drawColumnChart(sourceData,Xname) {
            this.chartColumn = echarts.init(document.getElementById('chartColumn'));
            var option = {
                // title:{
                //     text:"xxxx"
                // },
                legend: {},
                tooltip: {},
                dataset: {
                    dimensions: ['product', '申请总数', '成功数量', '失败数量'],
                    source: sourceData
                },
                xAxis: {
                    type: 'category',
                    name:Xname,
                    nameTextStyle:{
                        fontSize:16,
                        fontWeight:"bold",
                        align:"center",
                        verticalAlign:"middle",
                        rich: {
                            a: {
                                // 没有设置 `align`，则 `align` 为 right
                                align:"center"
                            }
                        }
                    }

                },
                yAxis: {
                    name:"相关撤除数量",
                    nameTextStyle:{
                        fontSize:16,
                        fontWeight:"bold",
                    }
                },
                series: [
                    {type: 'bar'},
                    {type: 'bar'},
                    {type: 'bar'}
                ]
            }
            this.chartColumn.setOption(option);
            this.chartColumn.resize();
        },
        getCount(){
            var _this = this;
            //this.radioValue=this.radio
            this.radioValue=1;
            console.log(this.radio);
            if(this.radio==1){//按年统计
            _this.tableHeaderDetail=[
                    {prop: 'CreateYear', label: '年份'},
                    {prop: 'SUMCount', label: '撤除申请总数'},//
                    {prop: 'SuccessCount', label: '撤除成功总数'},
                    {prop: 'FailCount', label: '撤除失败总数',},
                ]
                if(_this.value1==""||_this.value2==""){
                    this.$message({
                        message: '请先选择时间',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return false;
                }
                if(Date.parse(_this.value1)>Date.parse(_this.value2)){
                    this.$message({
                        message: '开始时间应小于结束时间',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return false;
                }
                var paramsData = {
                    countType:"year",
                    beginTime:_this.value1+'-01-01',
                    endTime:_this.value2+'-12-31'
                }
                _this.tableTitle=""+_this.value1+"年至"+_this.value2+"年撤除申请数量统计表"
                _this.chartTitle=""+_this.value1+"年至"+_this.value2+"年撤除申请数量柱状图"
                _this.getTableDataDetail(paramsData)
            }else{
            _this.tableHeaderDetail=[
                    {prop: 'CreateYear', label: '月份'},
                    {prop: 'SUMCount', label: '撤除申请总数'},//
                    {prop: 'SuccessCount', label: '撤除成功总数'},
                    {prop: 'FailCount', label: '撤除失败总数',},
                ]
            if(_this.value3==""||_this.value4==""){
                    this.$message({
                        message: '请先选择时间',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return false;
                }
                if(Date.parse(_this.value3)>Date.parse(_this.value4)){
                    this.$message({
                        message: '开始时间应小于结束时间',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return false;
                }
                var paramsData = {
                    countType:"month",
                    beginTime:_this.value3+'-01',
                    endTime:_this.value4+'-31'
                }

                _this.tableTitle=""+_this.value3.split("-")[0]+"年"+_this.value3.split("-")[1]+"月至"+_this.value4.split("-")[0]+"年"+_this.value4.split("-")[1]+"撤除申请数量统计表"
                _this.chartTitle=""+_this.value3.split("-")[0]+"年"+_this.value3.split("-")[1]+"月至"+_this.value4.split("-")[0]+"年"+_this.value4.split("-")[1]+"撤除申请数量柱状图"
                _this.getTableDataDetail(paramsData);
              // this.drawColumnChart2()

            }
        }
    },
    mounted: function () {
        //this.drawColumnChart()
        //this.drawColumnChart2()
    },
    // updated: function () {
    //     this.drawColumnChart()
    // }

}
</script>
<style>

 .el-input__inner{
         height: 34px;
     }
</style>

<style <style lang="scss" scoped>
    .condition_box{
        border:1px solid #DCDFE6;
        padding-top: 10px;
        // border-bottom:none;
    }
     .toolbar{
        background: transparent;
        padding: 0;
        margin: 0px;
        margin-left:20px;
        margin-bottom:10px;

     }
     .inp_title{
        display:inline-block;
        width:112px;
        text-align: right;
     }
    .chaxun_btn{
        height:34px;
        margin-left:1219px;
        line-height:10px;
    }
    .table_box{
        width: 100%;
        margin-top:20px;
        display:none;
        .table_con{
            margin:0 auto;
        }
        .table_title{
            height: 30px;
            text-align: center;
            font-size: 20px;
            font-weight: bold;
            padding-top: 20px;
        }

    }
    .toexcel{
        margin-bottom:5px;
    }
    .page_box{
        margin-top:10px;
    }
    .chart-container{
        margin-top:20px;
    }
    .showTable{
        display: block;
    }
</style>




// WEBPACK FOOTER //
// infoCount.vue?46f30ea6